import { Tooltip } from '@mui/material';
import React from 'react';

import { CircleButton } from 'src/common/ui/components';
import { inject } from 'src/util/inject';

interface EventCreateIconProps {
  rootStore: {
    events;
    auth: { user };
  };
}

const EventCreateIcon: React.VFC<EventCreateIconProps> = function EventCreateIcon({
  rootStore: {
    events,
    auth: { user },
  },
}) {
  return (
    <Tooltip title="Add Event">
      {/** Tooltip requires a ref-able component as a child */}
      <span>
        <CircleButton
          color="transparent-inverted"
          data-testid="event-create-icon"
          icon="addEvent"
          onClick={() => events.createEvent(user, {})}
        />
      </span>
    </Tooltip>
  );
};

export default inject<typeof EventCreateIcon>('rootStore')(EventCreateIcon);
